import { Typography } from "antd";

function AppFooter (){
   return <div className="ContentFooter">
    <div className="container AppFooter">
      <Typography.Link>+01097226321</Typography.Link>
      <Typography.Link>Privacy Policy</Typography.Link>
      <Typography.Link>Terms Of Use</Typography.Link>
   </div>
   </div>
}
export default AppFooter;